import React, { Dispatch, useEffect, useState } from 'react';
import { Radio } from 'common/components';
import classNames from 'classnames';
import { Action, Data } from '../../ThemeSettingContent';
import './Logo.scss';
import LogoCustom from './LogoCustom';

type RadioItem = { use_custom_logo: boolean; custom_logo: string; base64String: string };
type LogoImage = { computedRadioValue: number; use_custom_theme: boolean; custom_logo: string };

const getComputedRadioValue = (radio: RadioItem) => {
  if (radio.use_custom_logo) {
    if (radio.custom_logo === '') return 2;
    return 1;
  }
  return 0;
};

const LogoImage = ({ computedRadioValue, use_custom_theme, custom_logo }: LogoImage) => {
  const logo = ['기본 로고', custom_logo, '사용 안 함'];

  if (!use_custom_theme) return <span>기본 로고</span>;
  return (
    <>
      {computedRadioValue === 1 ? (
        <img src={logo[computedRadioValue]} alt="logo" />
      ) : (
        <span>{logo[computedRadioValue]}</span>
      )}
    </>
  );
};

interface Props {
  edit: boolean;
  datas: Data;
  setState: Dispatch<Action>;
}
const Logo = ({ edit, datas, setState }: Props) => {
  const [radioValue, setRadioValue] = useState<RadioItem>({
    use_custom_logo: false,
    custom_logo: '',
    base64String: '',
  });
  const computedRadioValue = getComputedRadioValue(radioValue);

  const logoImageExistence = () => {
    if (datas.base64String.length > 0) {
      setState({
        type: 'setData',
        payload: { ...datas, use_custom_logo: true, custom_logo: datas.base64String },
      });
    } else {
      setState({
        type: 'setData',
        payload: { ...datas, use_custom_logo: true, custom_logo: 'custom' },
      });
    }
  };

  useEffect(() => {
    const { use_custom_logo, custom_logo, base64String } = datas;
    setRadioValue({ use_custom_logo, custom_logo, base64String });
  }, [datas]);

  const radioChangeHandler = (value: number) => {
    if (value === 0) setState({ type: 'setData', payload: { ...datas, use_custom_logo: false, custom_logo: '' } });
    if (value === 1) logoImageExistence();
    if (value === 2) setState({ type: 'setData', payload: { ...datas, use_custom_logo: true, custom_logo: '' } });
  };

  return (
    <div id="admin-manage-theme-logo" className={classNames({ edit })}>
      <h4>{!edit && '현재 '}로고 이미지</h4>
      {edit ? (
        <div>
          <Radio.Group value={computedRadioValue} styles={{ fontSize: 16 }} onChange={radioChangeHandler}>
            <Radio.Item text="기본 로고" value={0} />
            <Radio.Item text="사용자 지정" value={1} />
            {computedRadioValue === 1 ? <LogoCustom datas={datas} setState={setState} /> : <></>}
            <Radio.Item text="사용 안 함" value={2} />
          </Radio.Group>
        </div>
      ) : (
        <LogoImage
          computedRadioValue={computedRadioValue}
          use_custom_theme={datas.use_custom_theme}
          custom_logo={datas.custom_logo}
        />
      )}
    </div>
  );
};

export default Logo;
